module.exports = __webpack_public_path__ + "static/images/0796af8afd4b765723b0972ad1451ed0.webp";